export default __webpack_public_path__ + "static/media/salesforce_logo.565507c3.svg";